export function upsertById(array, newObj) {
  const existingItem = array.find(item => item.id === newObj.id);
  return existingItem
    ? array.map(item => (item.id === newObj.id ? { ...item, ...newObj } : item))
    : [...array, newObj];
}

export function getOutOfOrderValues<T>(values: T[], expectedValues: T[]): T[] {
  // Step through both lists synchronously, index by index, until there is a mismatch between the two lists
  // Continue stepping through `values` until we find the value was expected to appear in `expectedIds`
  // Every step where there is a mismatch, append the mismatching value to outOfOrderValues.
  // Once the match has been found, continue stepping through both lists synchronously until
  // there are no more values in either `values` or `expectedValues`

  // Store a list of values from `values` which were not in the same order as they are in `expectedValues`
  const outOfOrderValues: T[] = [];

  const actualLength = values.length;
  const expectedLength = expectedValues.length;

  for (
    let valuesIndex: number = 0, expectedValuesIndex: number = 0;
    valuesIndex < actualLength && expectedValuesIndex < expectedLength;
    valuesIndex += 1
  ) {
    // Get the value as it is, in the order provided
    const actualValue = values[valuesIndex];
    // Get the value from
    const expectedValue = expectedValues[expectedValuesIndex];

    if (actualValue === expectedValue) {
      // There was a match, advance the expectedValuesIndex (the valuesIndex will be advanced, too)
      expectedValuesIndex += 1;
    } else {
      // There is a mismatch, this value was not in the same order as in the expectedValues list
      outOfOrderValues.push(actualValue);
    }
  }
  return outOfOrderValues;
}
